import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useParams } from 'react-router-dom';
import { getBooks } from "./actions";
import classNames from "classnames";
import _ from "lodash";
import withPaging from "../common/withPaging";
import { Link } from "react-router-dom";

const Books = (props) => {
  const { books, booksPaging, pageNumber } = props;

  const {eventId} = useParams();
  const [deleteBookId, setDeleteBookId] = useState(-1);

  useEffect(() => {
    const query = {
      sortBy: 1,
      pageNumber,
      pageSize: 10,
      storeId:Number(eventId)
    };
    props.getBooks(query);
  }, [pageNumber]);

  const onDeleteBook = (bookId) => {

  };

  return (
    <Fragment>
      <div className="maximumSizeHandler">
        <div className="contentTitle">
          <span className=" font-size_24 boldFont middleContext">
            لیست تمامی کتاب ها
          </span>
          <Link to="/books/new">
            <div className="normalButton outlineMode greenButton">
              <span className="icon icon-add-book font-size_24 middleContext"></span>{" "}
              افزودن کتاب جدید
            </div>
          </Link>
        </div>
      </div>
      <span className="lineSeparator"></span>
      <div className="maximumSizeHandler">
        <div className="tableActions">
          <div className="">
            <div className="normalButton outlineMode greenButton">
              <span className="icon icon-download font-size_24 middleContext"></span>{" "}
              دانلود الگو
            </div>
            <div className="normalButton fillMode originalButton">
              <span className="icon icon-upload font-size_24 middleContext"></span>{" "}
              آپلود فایل Excel
            </div>
          </div>
          <div className="">
            <div className="standardLink excelColor">
              <span className="icon icon-excel"></span> دانلود Excel لیست
            </div>
          </div>
        </div>

        <div className="tableStructure">
          <table>
            <tr className="font-size_16 mediumWFont">
              <th></th>
              <th>عنوان کتاب</th>
              <th>قیمت</th>
              <th>نویسنده</th>
              <th>ناشر</th>
              <th>مترجم</th>
              <th>دسته بندی</th>
              <th>ISBN</th>
              <th></th>
            </tr>
            {!_.isEmpty(booksPaging) && booksPaging[pageNumber]
              ? _.map(booksPaging[pageNumber], (id) => {
                  return (
                    <tr className="font-size_14">
                      <td>
                        <img src={books[id].thumbnail} />
                      </td>
                      <td>{books[id].name}</td>
                      <td>{books[id].price}</td>
                      <td>{books[id].authorName}</td>
                      <td>{books[id].publisher}</td>
                      <td>{books[id].translators}</td>
                      <td>{books[id].category}</td>
                      <td>{books[id].isbn}</td>
                      <td>
                        <Link to={`/books/${id}`}>
                          <span className="icon icon-edit greenColor"></span>
                        </Link>
                      </td>
                      <td>
                        <span
                          className="icon icon-eraser redColor"
                          onClick={(e) => {
                            setDeleteBookId(id);
                          }}
                        ></span>
                      </td>
                      {/*<td className="blueColor">مشاهده نتایج <span className="icon icon-left font-size_12"></span></td>*/}
                    </tr>
                  );
                })
              : null}
          </table>
        </div>
        {!_.isEmpty(books)
          ? props.paginationRender(
              pageNumber,
              Math.ceil(books[booksPaging[1][0]].totalCount / 10)
            )
          : null}
      </div>

      <div className={classNames("popUp", deleteBookId == -1 && "tempDisable")}>
        <div className="popUpClose"></div>
        <div className="popUpBox whiteBox relative">
          <div className="popUpCloseSign">
            <span className="icon icon-close"></span>
          </div>
          <div className="popUpTitle font-size_20">
            آیا از حذف کتاب مورد نظر مطمئن هستید؟
          </div>
          <div className="popUpOptions textInLeft topColumnMargin">
            <span
              className="redColor leftMargin"
              onClick={(e) => {
                onDeleteBook(deleteBookId);
              }}
            >
              حذف مورد
            </span>
            <span
              className=""
              onClick={(e) => {
                setDeleteBookId(-1);
              }}
            >
              انصراف
            </span>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

const mapStateToProps = ({ books, booksPaging }) => ({
  books,
  booksPaging,
});

export default connect(mapStateToProps, { getBooks })(withPaging(Books));
